// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__vBpH4","modalFooterButton":"ModalNotes_modalFooterButton__16mkp"};